import React, { Fragment, useEffect, useId } from 'react';
import PropTypes from 'prop-types';
import { size } from 'lodash-es';
import classnames from 'classnames';
import {
  ColorListSmartV2,
  ColorsEntities,
} from 'site-modules/shared/components/color-list-smart-v2/color-list-smart-v2';
import { FieldError } from 'client/site-modules/shared/components/field-error/field-error';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { APPRAISAL_PAGE_CREATIVE_ID } from 'site-modules/shared/constants/appraisal/appraisal';

export function ColorsSection({
  colors = [],
  selectedColor = {},
  onColorSelect,
  sectionName = '',
  sectionKey = '',
  errorMap = {},
  className = '',
  titleClassName = 'mb-0_5',
  isExtendedReport = false,
}) {
  const hasColors = !!size(colors);
  const error = errorMap.get(sectionKey);
  const errorId = `${sectionKey}-error-${useId()}`;

  const CategoryTitle = isExtendedReport ? 'h3' : 'h4';

  useEffect(() => {
    if (error) {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
        event_data: {
          action_name: TrackingConstant.ACTION_APPRAISE_VEHICLE,
          action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
          subaction_name: TrackingConstant.SUBMIT_EXTERIOR_COLOR,
          creative_id: APPRAISAL_PAGE_CREATIVE_ID,
          action_category: TrackingConstant.USER_ACTION_CATEGORY,
          value: 'error_no_color_selected',
        },
      });
    }
  }, [error]);

  return (
    <fieldset className={classnames('colors-section', className, sectionKey)}>
      <legend className={classnames('size-16 fw-bold d-inline-block', titleClassName)}>
        <CategoryTitle className="size-16 d-inline-block mb-0">{sectionName}</CategoryTitle>
        {': '}
        <span className="fw-normal">{Object.keys(selectedColor)[0]}</span>
      </legend>
      {!hasColors ? (
        <div data-testid="no-colors-text" className="mb-1_5">
          Sorry, we couldn&apos;t find any colors for this vehicle.
        </div>
      ) : (
        <Fragment>
          <FieldError id={errorId} error={error} classes="color-error" />
          <ColorListSmartV2
            listItems={colors}
            selectedItems={selectedColor}
            showCheckmark={false}
            updateHOCState={onColorSelect}
            listName={sectionName}
            {...(error ? { ariaDescribedBy: errorId, ariaInvalid: true } : {})}
          />
        </Fragment>
      )}
    </fieldset>
  );
}

ColorsSection.propTypes = {
  colors: ColorsEntities.Colors,
  selectedColor: ColorsEntities.Color,
  onColorSelect: PropTypes.func.isRequired,
  sectionName: PropTypes.string,
  errorMap: PropTypes.objectOf(PropTypes.string),
  sectionKey: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  titleClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  isExtendedReport: PropTypes.bool,
};
